import { render } from "./OptionsMenu.vue?vue&type=template&id=5164ef80&scoped=true"
import script from "./OptionsMenu.vue?vue&type=script&lang=js"
export * from "./OptionsMenu.vue?vue&type=script&lang=js"

import "./OptionsMenu.vue?vue&type=style&index=0&id=5164ef80&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5164ef80"]])

export default __exports__